module.exports = __webpack_public_path__ + "img/x7.756582a4.jpg";